import React, { useState } from 'react';
import styles from './EditableContent.module.scss';

import { useMobileViewport } from 'hooks/useMobileViewport';

import { Button, IconButton } from '@material-ui/core';

import CloseIcon from '@material-ui/icons/Close';
import CheckIcon from '@material-ui/icons/Check';
import CreateIcon from '@material-ui/icons/Create';

import clsx from 'clsx';

export function EditableContent({
  onAccept,
  isEditable = true,
  setDefaultValue,
  renderDisplayedComponent,
  renderEditor,
  hoverPencil = false,
  onEditClick
}) {
  const isMobile = useMobileViewport();

  const [open, setOpen] = useState(false);

  const handleEditClick = () => {
    if (onEditClick) {
      onEditClick();
    } else {
      setDefaultValue && setDefaultValue();
      setOpen(true);
    }
  };
  const closeEditing = () => setOpen(false);

  const handleAccept = () => {
    onAccept();
    closeEditing();
  };

  return !open ? (
    <div className={clsx(styles.displaying, hoverPencil && !isMobile && styles.hoverPencil)}>
      {renderDisplayedComponent()}

      {!!isEditable && (
        <IconButton className={styles.displaying__pencil} onClick={handleEditClick}>
          <CreateIcon />
        </IconButton>
      )}
    </div>
  ) : (
    <div className={styles.editing}>
      {renderEditor()}
      <div className={styles.helpers}>
        <Button onClick={closeEditing} className={styles.alert}>
          <CloseIcon />
        </Button>
        <Button onClick={handleAccept} className={styles.success}>
          <CheckIcon />
        </Button>
      </div>
    </div>
  );
}
